<template>
    <b-modal
        v-model="modalVisible"
        title="Import Customers"
        hide-footer
        size="lg"
    >
        <b-card no-body>
            <b-tabs card>
                <b-tab title="Upload Customers" active>
                    <b-card-body
                        title="Import Customers"
                        v-show="!customerList.length"
                    >
                        <simple-csv-import
                            v-model="customerList"
                            :startRowNo="dataSettings.rowno"
                            :columnsMap="columnsMap"
                        >
                        </simple-csv-import>
                    </b-card-body>

                    <b-card-body v-show="customerList.length > 0">
                        <b-container>
                            <b-row>
                                <b-col> Total Customers: </b-col>
                                <b-col>
                                    {{ customerList.length }}
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col> Status: </b-col>
                                <b-col> Ready to Upload </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <b-button
                                        v-show="customerList.length > 0"
                                        @click="cancel()"
                                        variant="outline-danger"
                                    >
                                        Cancel
                                    </b-button>
                                    <b-button
                                        v-show="customerList.length > 0"
                                        @click="importCustomer"
                                        variant="success"
                                    >
                                        Begin Upload
                                    </b-button>
                                </b-col>
                            </b-row>
                            <b-table
                                :items="statusList"
                                responsive
                                :per-page="perPage"
                                :current-page="currentPage"
                                :fields="tableFields"
                            >
                                <template #cell(status)="data">
                                    <b-badge
                                        :id="`upload-customer-${data.index}`"
                                        :variant="
                                            data.value | filterStatusVariant
                                        "
                                        >{{ data.value }}</b-badge
                                    >
                                    <!-- Show tooltip if there are errors -->
                                    <b-tooltip
                                        v-if="data.item.error_list.length > 0"
                                        :target="`upload-customer-${data.index}`"
                                        triggers="hover"
                                    >
                                        Errors:
                                        <!-- loop through the list of errors and display each -->
                                        <ul
                                            v-for="error_set in data.item
                                                .error_list"
                                            :key="error_set.index"
                                        >
                                            <li
                                                v-for="error in error_set[1]"
                                                :key="`error-${error}`"
                                            >
                                                {{ error }}
                                            </li>
                                        </ul>
                                    </b-tooltip>
                                </template>
                            </b-table>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="statusList.length"
                                :per-page="perPage"
                                aria-controls="my-table"
                            ></b-pagination>
                        </b-container>
                    </b-card-body>
                </b-tab>
                <b-tab title="Settings">
                    <b-card-body>
                        <upload-data-settings
                            @input="updateConfiguration"
                            :value="dataSettings"
                            :data-fields="customerFields"
                        ></upload-data-settings>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-modal>
</template>

<script>
const key = 'customerUploadSettings'
import SimpleCsvImport from '@/components/SimpleCsvImport'
import UploadDataSettings from '@/components/UploadDataSettings'
import { capitalCase } from 'change-case'
import popupMixins from '@/mixins/popupMixins'

/** The fields for the customer and whether they are required */
const customerFields = [
    { name: 'code', required: true },
    { name: 'name', required: true },
    { name: 'email', required: false },
    { name: 'address1', required: false },
    { name: 'address2', required: false },
    { name: 'city', required: false },
    { name: 'country_code', required: false },
]

/**
 * The possible statuses during upload
 */
const statuses = {
    COMPLETE: 'complete',
    ERROR: 'error: hover for details',
    PENDING: 'ready',
    CHECKING: ' checking',
    SAVING: 'saving',
    INVALID_LOCATION: 'complete: invalid location',
    GEOCODING: 'geocoding',
}

export default {
    name: 'import-customer-form',
    components: { SimpleCsvImport, UploadDataSettings },
    props: ['value'],
    mixins: [popupMixins],
    data: () => {
        return {
            dataSettings: {},
            perPage: 15,
            currentPage: 1,
            modalVisible: false,
            customerFields,
            customerList: [],
            files: [],
            file: {},
            status: false,
            model: customerFields.reduce((obj, field) => {
                obj[field] = field == 'country' ? 'Jamaica' : ''
                return obj
            }, {}),
            submitting: false,
            hasErrors: false,

            statusList: [],
        }
    },

    filters: {
        filterStatusVariant(status) {
            console.log('status', status)
            switch (status) {
                case statuses.INVALID_LOCATION:
                    return 'warning'
                case statuses.ERROR:
                    return 'danger'
                case statuses.COMPLETE:
                    return 'success'
                default:
                    return 'light'
            }
        },
    },

    computed: {
        columnsMap() {
            const x = { ...this.dataSettings }
            delete x.rowno
            return x
        },

        configurations() {
            return this.$store.getters['company/configurations'] || []
        },

        tableFields() {
            const _fields = customerFields.map(x => ({
                key: x.name,
                label: x.name.toUpperCase(),
            }))
            _fields.unshift(
                { key: 'no', label: 'No', stickyColumn: true },
                { key: 'status', label: 'Status', stickyColumn: true }
            )
            return _fields
        },
    },
    watch: {
        configurations: {
            handler: function (val) {
                console.log('configurations-watch', val)
                this.dataSettings = JSON.parse(
                    ((val || []).find(x => x.key === key) || {}).text_value
                )
            },
            deep: true,
        },

        value: function (val) {
            this.modalVisible = val
        },
        customerList: {
            handler: function (val) {
                if (val.length > 0) {
                    this.loadStatusList()
                }
            },
            deep: true,
        },
    },
    mounted: function () {
        this.$store.dispatch('company/fetch')
        console.log('location', location.href)
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            console.log('Modal is about to be shown', bvEvent, modalId)
        })
        this.$root.$on('bv::modal::hide', () => {
            this.$emit('input', false)
        })       
    },
    methods: {
        /**
         * Where the value for the column index is -1, set the column setting to undefined.
         * @param data The data settings
         */
        preprocessDataSettings(data) {
            var dataCopy = { ...data }
            for (const [key, value] of Object.entries(dataCopy)) {
                dataCopy[key] = value == -1 ? undefined : value
            }
            return dataCopy
        },
        /**
         * Validates the form data based on whether the field is required or not
         * @param data The form data
         * @returns A list of errors if there are any or an empty list if there are none
         */
        validateDataSettings(data) {
            var errors = []
            for (const field of customerFields) {
                if (data[field.name] == undefined && field.required) {
                    errors.push(`${capitalCase(field.name)} is required`)
                }
            }
            return errors
        },
        updateConfiguration(data) {
            data = this.preprocessDataSettings(data)
            // validate data
            var result = this.validateDataSettings(data)

            // show errors if any
            if (result.length) {
                for (const err of result) {
                    this.doToast('Error', err, 'danger')
                }
                this.doToast('Error', 'Settings Update Failed', 'danger')
                // abort update due to errors
                return
            }

            const text_value = JSON.stringify(data)
            const bool_value = false
            this.$store
                .dispatch('company/updateConfiguration', {
                    key,
                    text_value,
                    bool_value,
                })
                .then(() =>
                    this.doToast(
                        'Success',
                        'Settings updated successfully',
                        'success'
                    )
                )
                .catch(err => {
                    console.log(err.response.data.error.message)
                    this.doToast(
                        'Error',
                        `Settings failed to update. ${err.response.data.error.message}`,
                        'danger'
                    )
                })
        },

        onSubmit(data) {
            console.log('data', data)
        },
        processError(err) {
            console.log('err', err)
        },
        loadStatusList() {
            this.statusList = this.customerList.map((x, i) => {
                let status = statuses.PENDING
                let no = i + 1
                return { ...{ no, status, error_list: [] }, ...x }
            })
        },
        checkEntry({ email, name }) {
            const emailRegex =
                /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
            if (email) {
                if (!emailRegex.test(email)) return -1
            }
            if (!/^[a-zA-Z0-9\s.-]+$/.test(name)) return 0
            return 1
        },

        previewFiles() {},
        cancel() {
            this.$emit('cancel')
            this.customerList = []
        },
        cancelCustomers() {
            this.customerList = []
        },

        async importCustomer() {
            var res = null
            for (let i = 0; i < this.customerList.length; i++) {
                this.statusList[i].status = statuses.CHECKING
                let {
                    code,
                    name,
                    email,
                    address1,
                    address2,
                    city,
                    country_code,
                } = this.customerList[i]
                var check = this.checkEntry({ email, name })
                if (check == 1) {
                    city = city || 'Kingston'
                    country_code = country_code || 'JM'
                    let location = { address1, address2, city, country_code }
                    console.log('netering ')
                    this.submitting = true
                    // try to find the location

                    try {
                        this.statusList[i].status = statuses.GEOCODING
                        const { latitude, longitude } =
                            await this.$store.dispatch(
                                'locations/geocodeAddress',
                                location
                            )
                        console.log('geocode', { latitude, longitude })
                        location = { ...location, ...{ latitude, longitude } }
                        this.statusList[i].status = statuses.SAVING
                        // try to upload order with location
                        res = await this.$store.dispatch(
                            'customers/uploadCustomer',
                            {
                                code,
                                name,
                                email,
                                location,
                            }
                        )

                        // set status to complete if the upload was successful
                        if (res.status_code == 200) {
                            this.statusList[i].status = statuses.COMPLETE
                        } else {
                            // add errors to error list and set error status if upload failed
                            this.statusList[i].error_list =
                                typeof res.message == 'string'
                                    ? [['error', [res.message]]]
                                    : Object.entries(res.message)
                            this.statusList[i].status = statuses.ERROR
                        }
                    } catch (err) {
                        console.warn(err)
                        //try to upload order without location
                        res = await this.$store.dispatch(
                            'customers/uploadCustomer',
                            {
                                code,
                                name,
                                email,
                                location,
                            }
                        )

                        // set status to complete with a warning if the upload was successful
                        if (res.status_code == 200) {
                            this.statusList[i].status =
                                statuses.INVALID_LOCATION
                        } else {
                            this.statusList[i].error_list =
                                typeof res.message == 'string'
                                    ? [['error', [res.message]]]
                                    : Object.entries(res.message)
                            this.statusList[i].status = statuses.ERROR
                        }
                    } finally {
                        this.submitting = false
                    }
                } else {
                    // set error status if the name or email fails validation
                    this.statusList[i].status = statuses.ERROR
                    if (check == 0) {
                        this.statusList[i].error_list = [
                            ['name', ['Invalid name']],
                        ]
                    }
                    if (check == -1) {
                        this.statusList[i].error_list = [
                            ['email', ['Invalid email format']],
                        ]
                    }
                }
            }
            //this.$emit('success')
            //this.$emit('cancel')
            //this.customerList = []
        },
        invalidateMap() {
            setTimeout(() => {
                this.$refs.map.mapObject.invalidateSize()
            }, 1000)
        },
    },
}
</script>

<style></style>
